<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <div class="columns is-desktop">
            <div class="column is-2">
              <div class="field">
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="perPage" @change="onPerPageChange">
                      <option value="10">10 per page</option>
                      <option value="25">25 per page</option>
                      <option value="50">50 per page</option>
                      <option value="100">100 per page</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <div class="control">
                  <input type="text" class="input" placeholder="Search" v-model="searchText" @input="changeSearchText">
                </div>
              </div>
            </div>
            <div class="column is-2">
              <button class="button is-info is-fullwidth" @click="onFilter">Search</button>
            </div>
            <div class="column is-2">
              <button @click="exportPage" class="button is-link is-fullwidth">Export Page</button>
            </div>
            <div class="column is-2">
                <a class="button is-link is-fullwidth" @click.prevent="downloadAllHistory">Export All</a>
            </div>
          </div>
          
          <b-table
            :data="records"
            :loading="isLoading"
            paginated
            backend-pagination
            :total="totalRows"
            :per-page="perPage"
            :current-page="currentPage"
            @page-change="onPageChange"
            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"

            detail-key="runId"
            @details-open="(row, index) => showDetailsForPageRun(row.pageRun)">
            <template slot-scope="props">
              <b-table-column field="id" label="Page ID" sortable numeric>{{ props.row.id }}</b-table-column>
              <b-table-column field="watchdogSetupDate" label="Watchdog setup date" sortable numeric>{{ props.row.watchdogSetupDate }}</b-table-column>
              <b-table-column field="email" label="Email" sortable numeric>{{ props.row.email }}</b-table-column>
              <b-table-column field="keyword" label="Keyword" sortable numeric>{{ props.row.keyword }}</b-table-column>
              <b-table-column field="numberOfWatchdogRuns" label="# of watchdog runs" numeric>{{ props.row.numberOfWatchdogRuns }}</b-table-column>
              <b-table-column field="frequency" label="Frequency" numeric>{{ props.row.frequency }}</b-table-column>
              <b-table-column field="lastReportSentOn" label="Last report sent on" numeric>{{ toLocalDateString(props.row.lastReportSentOn) }}</b-table-column>
              <b-table-column field="nextReportWillSendOn" label="Next report will send on" sortable numeric>{{ toLocalDateString(props.row.nextReportWillSendOn) }}</b-table-column>
              <b-table-column field="numberOfFailedReports" label="Number of failed reports" numeric>{{ props.row.numberOfFailedReports }}</b-table-column>
            </template>
          </b-table>
        </div>
      </div>
  
    </div>
  </section>
  </template>
  
  <script>
import { downloadServedFile } from '@/utils/served-files'
  import { mixin } from '@/components/mixin'
  import { mixin as exportmixin } from '@/components/export_mixin'
  import { toLocalDateString } from '@/utils'
  
  export default {
    components: {},
    mixins: [mixin, exportmixin],
    data () {
      return {
        records: [],
        totalRows: 0,
        isLoading: false,
        sortField: 'id',
        sortOrder: 'desc',
        defaultSortOrder: 'asc',
        currentPage: 1,
        perPage: 25,
        isSimple: false,
        isRounded: false,
        searchText: '',
        proxies: [],
      }
    },
    computed: {
      currentUser () {
        if (this.$store.state.user) {
          return this.$store.state.user
        }
        return {}
      }
    },
    methods: {
    downloadAllHistory () {
      downloadServedFile('watchdog_allhistory.txt')
    },
      getBaseUrl (fullUrl) {
        let pathArray = fullUrl.split( '/')
        let protocol = pathArray[0]
        let host = pathArray[2]
        let url = protocol + '//' + host
        return url
      },
      exportPage () {
        let data = this.records.map(record => `${record.runId},"${this.toLocalDateString(record.createdAt)}",${record.email},${record.keyword},${record.status},${record.url},${record.score}`)
        data = ['Run ID,Created At, User Email,Keyword,Status,Target Url,Score'].concat(data).join('\n')
        const now = new Date();
        const fileName = "WatchdogHistory_" + now.getUTCFullYear() + "_" + (now.getUTCMonth()+1) + "_"+ now.getUTCDate() + ".csv"
        this.exportToCSV(data, fileName)
      },
      toLocalDateString (dateStr) {
        return toLocalDateString(dateStr)
      },
      onPerPageChange () {
        this.$nextTick(() => this.loadData())
      },
      onPageChange (page) {
        this.currentPage = page
        this.loadData()
      },
      onSort (field, order) {
        this.sortField = field
        this.sortOrder = order
        this.loadData()
      },
      onFilter () {
        // console.log('filtering')
        this.$nextTick(() => {
          this.loadData()
        })
      },
      loadData () {
        this.isLoading = true
        this.$store.commit('showLoading')
        const params = [
          `sortField=${this.sortField}`,
          `sortOrder=${this.sortOrder}`,
          `page=${this.currentPage}`,
          `perPage=${this.perPage}`,
          `filterText=${this.searchText}`
        ].join('&')
        this.$store.dispatch('getWatchDogTrackHistoryForAdmin', { params })
          .then(({ data }) => {
            const { total, records } = data
            this.totalRows = total
            this.records = records
            this.isLoading = false
            this.$store.commit('hideLoading')
          })
      },
      changeSearchText () {
        console.log(this.searchText);
      }
    },
    beforeMount () {
      // this.loadData()
    }
  }
  </script>
  
  <style lang="scss">
  .table-mobile-sort {
    display: none;
  }
  </style>
  